import { TopBar } from "@/components/TopBar";
import { VmCard } from "@/components/vm/VmCard";
import { useVmStatus } from "@/hooks/useVmStatus";

export function VmControl() {
  const { data, error, loading, refetch } = useVmStatus(true);

  return (
    <div className="min-h-full">
      <TopBar />
      <main className="flex flex-1 items-start justify-center px-4 py-12 sm:py-20">
        <VmCard data={data} error={error} loading={loading} refetch={refetch} />
      </main>
    </div>
  );
}
